import React from "react";
import { Line } from "react-chartjs-2";
import "../InsuranceDashboard.css";

export const InsuranceInfo = () => {
  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      // {
      //   label: "Net Income",
      //   type: "line",
      //   data: [23, 63, 35, 41, 44, 75, 13, 18, 22, 34, 45,78],
      //   fill: false,
      //   borderColor: "#11C4C1",
      // },
      {
        type: "bar", // Stacked bar dataset 1
        label: "Honda Auto Insurance",
        data: [12, 19, 3, 5, 2, 3, 8, 6, 7, 56, 32, 23],
        backgroundColor: "#B9C4FF",
        stack: "stack1",
      },
      {
        type: "bar", // Stacked bar dataset 3
        label: "Wife’s Life Insurance Policy",
        data: [3, 10, 13, 15, 22, 30, 12, 9, 10, 45, 87, 77],
        backgroundColor: "#2A3DA3",
        stack: "stack1",
      },
      {
        type: "bar", // Stacked bar dataset 2
        label: "Family Health Insurance",
        data: [2, 3, 20, 5, 1, 4, 10, 7, 6, 56, 34, 56],
        backgroundColor: "#7A87D1",
        stack: "stack1",
      },
      // {
      //   type: "bar", // Stacked bar dataset 2
      //   label: "eBay Sales",
      //   data: [2, 3, 20, 5, 1, 4, 10, 7, 6,56,34,56],
      //   backgroundColor: "#eaebf2",
      //   stack: "stack1",
      // },
    ],
  };
  return (
    <React.Fragment>
      <div className="incomeInfoMaincard">
        <h3
          className="incomecardheading"
          style={{ textAlign: "center", fontSize: "16px" }}
        >
          Monthly Premiums
        </h3>
        <div style={{ marginTop: "1rem" }}>
          <Line
            data={data}
            height={80}
            options={{
              legend: {
                display: true,
              },

              scales: {
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                    ticks: {
                      beginAtZero: true,
                      callback: function (value) {
                        return new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                      },
                    },
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
              },
              plugins: {},
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
